export { default as EditIcon } from '~icons/lucide/edit-2';
